<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Usuário Adminstrador</h5>
                <hr>
                <Toolbar class="p-mb-4">
                    <template slot="left">
                        <Button type="button" icon="pi pi-plus" label="Novo" class="p-mr-2" @click="abrirNovo"/>
                    </template>
                </Toolbar>
                <DataTable :value="usuarios" :autoLayout="true" :filters="filtros" :paginator="true" :rows="10"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    :rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
                    class="p-datatable-sm p-datatable-striped">
                    <template #header>
                        <div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                            <span></span>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filtros['global']" placeholder="Filtrar..." />
                            </span>
                        </div>
                    </template>
                    <Column field="nome" header="Nome" sortable></Column>
                    <Column field="email" header="E-mail" sortable></Column>
                    <Column field="ativo" header="Status" sortable>
                        <template #body="{data}">
                            <span :class="data.ativo ? 'p-tag p-tag-success' : 'p-tag p-tag-danger'">
                                {{ data.ativo ? 'Ativo' : 'Inativo' }}
                            </span>
                        </template>
                    </Column>
                    <Column>
                        <template #body="slotProps">
                            <Button v-if="!slotProps.data.ativo" icon="pi pi-check-circle" title="Ativar"
                                class="p-button-rounded p-button-success p-mr-2" @click="confirmarAtivar(slotProps.data)"/>
                            <Button v-if="slotProps.data.ativo" icon="pi pi-ban" title="Desativar"
                                class="p-button-rounded p-button-warning p-mr-2" @click="confirmarDesativar(slotProps.data)"/>
                            <Button icon="pi pi-trash" title="Excluir"
                                class="p-button-rounded p-button-danger" @click="confirmarExcluir(slotProps.data)"/>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>

        <!-- Dialog Novo Usuário -->
        <Dialog :visible.sync="exibirDialogForm" header="Novo Usuário" :modal="true" class="p-fluid" :style="{width: '30vw'}">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12">
                    <label for="nome">Nome</label>
                    <InputText id="nome" v-model="usuario.nome" autocomplete="off"
                        :class="{'p-invalid': enviandoForm && !usuario.nome}"/>
                    <small class="p-invalid" v-if="enviandoForm && !usuario.nome">Informe o nome</small>
                </div>
                <div class="p-field p-col-12">
                    <label for="email">E-mail</label>
                    <InputText id="email" v-model="usuario.email" autocomplete="off"
                        :class="{'p-invalid': enviandoForm && !usuario.email}"/>
                    <small class="p-invalid" v-if="enviandoForm && !usuario.email">Informe o e-mail</small>
                </div>
            </div>
            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharDialogForm"/>
                <Button label="Salvar" icon="pi pi-check" class="p-button-primary" @click="salvar"/>
            </template>
        </Dialog>

        <!-- Dialog Confirmar Ativar -->
        <Dialog :visible.sync="exibirDialogAtivar" header="Confirmar Ativação" :modal="true" :style="{width: '400px'}">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color: orange" />
                <span>Ativar o usuário <b>{{ usuarioSelecionado && usuarioSelecionado.nome }}</b>?</span>
            </div>
            <template #footer>
                <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogAtivar = false"/>
                <Button label="Sim" icon="pi pi-check" class="p-button-success" @click="ativar"/>
            </template>
        </Dialog>

        <!-- Dialog Confirmar Desativar -->
        <Dialog :visible.sync="exibirDialogDesativar" header="Confirmar Desativação" :modal="true" :style="{width: '400px'}">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color: orange" />
                <span>Desativar o usuário <b>{{ usuarioSelecionado && usuarioSelecionado.nome }}</b>?</span>
            </div>
            <template #footer>
                <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogDesativar = false"/>
                <Button label="Sim" icon="pi pi-check" class="p-button-warning" @click="desativar"/>
            </template>
        </Dialog>

        <!-- Dialog Confirmar Excluir -->
        <Dialog :visible.sync="exibirDialogExcluir" header="Confirmar Exclusão" :modal="true" :style="{width: '400px'}">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color: red" />
                <span>Excluir o usuário <b>{{ usuarioSelecionado && usuarioSelecionado.nome }}</b>?</span>
            </div>
            <template #footer>
                <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogExcluir = false"/>
                <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir"/>
            </template>
        </Dialog>
    </div>
</template>

<script>
import UsuarioIKAcessoService from '@/service/UsuarioIKAcessoService';
import { exibirMensagem, exibirMensagemSis } from '@/global';

export default {   
    data() {
        return {
            usuarios: [],
            usuario: { nome: null, email: null },
            usuarioSelecionado: null,
            filtros: {},
            enviandoForm: false,
            exibirDialogForm: false,
            exibirDialogAtivar: false,
            exibirDialogDesativar: false,
            exibirDialogExcluir: false,
        };
    },
    methods: {
        listar() {
            this.usuarioService.listar()
                .then(resp => { this.usuarios = resp.data; })
                .catch(erro => { exibirMensagem(this, erro); });
        },
        abrirNovo() {
            this.usuario = { nome: null, email: null };
            this.enviandoForm = false;
            this.exibirDialogForm = true;
        },
        salvar() {
            this.enviandoForm = true;
            if (!this.usuario.nome || !this.usuario.email) return;
            const payload = { ...this.usuario, clienteId: this.clienteId };
            this.usuarioService.salvar(payload)
                .then(() => {
                    this.fecharDialogForm();
                    this.listar();
                    exibirMensagemSis(this, 'Sucesso', false);
                })
                .catch(erro => { exibirMensagem(this, erro); });
        },
        fecharDialogForm() {
            this.exibirDialogForm = false;
            this.usuario = { nome: null, email: null };
            this.enviandoForm = false;
        },
        confirmarAtivar(usuario) {
            this.usuarioSelecionado = usuario;
            this.exibirDialogAtivar = true;
        },
        ativar() {
            this.usuarioService.ativar(this.usuarioSelecionado.id)
                .then(() => {
                    this.exibirDialogAtivar = false;
                    this.listar();
                    exibirMensagemSis(this, 'Usuário ativado com sucesso', false);
                })
                .catch(erro => { exibirMensagem(this, erro); });
        },
        confirmarDesativar(usuario) {
            this.usuarioSelecionado = usuario;
            this.exibirDialogDesativar = true;
        },
        desativar() {
            this.usuarioService.desativar(this.usuarioSelecionado.id)
                .then(() => {
                    this.exibirDialogDesativar = false;
                    this.listar();
                    exibirMensagemSis(this, 'Usuário desativado com sucesso', false);
                })
                .catch(erro => { exibirMensagem(this, erro); });
        },
        confirmarExcluir(usuario) {
            this.usuarioSelecionado = usuario;
            this.exibirDialogExcluir = true;
        },
        excluir() {
            this.usuarioService.excluir(this.usuarioSelecionado.id)
                .then(() => {
                    this.exibirDialogExcluir = false;
                    this.listar();
                    exibirMensagemSis(this, 'Usuário excluído com sucesso', false);
                })
                .catch(erro => { exibirMensagem(this, erro); });
        },
    },
    created() {
        this.usuarioService = new UsuarioIKAcessoService();
    },
    mounted() {
        this.listar();
    }
};
</script>
